import { classInfo, instanceEmitter, folderEmitter } from '../CalendarState'
import { _createInstances } from '../EventInstanceManager'
import type { AppCalendar, CalendarEventObject } from '../CalendarSync'
import { _upsertCalendar } from './calendarHelpers'

/**
 * 캘린더의 이벤트와 인스턴스를 교체한다.
 * 기존 + 새 이벤트 키로 중복 인스턴스를 emit 없이 제거하여 깜빡임을 방지한다.
 */
export const _replaceCalendarEvents = (
  calendar: AppCalendar,
  newEvents: Record<string, CalendarEventObject>,
  options?: { skipEmit?: boolean },
): void => {
  const allKeys = new Set([...Object.keys(calendar.events), ...Object.keys(newEvents)])
  classInfo.instances = classInfo.instances.filter((i) => !allKeys.has(i.serverId))
  calendar.events = newEvents
  _upsertCalendar(calendar)
  classInfo.instances = _createInstances(newEvents, true, classInfo.instances)
  if (!options?.skipEmit) {
    instanceEmitter.emit('instance')
    folderEmitter.emit('folder')
  }
}
